module.exports = __webpack_public_path__ + "img/IMG_1766.d89369dd.jpeg";